import { getAppInsights } from "./TelemetryService";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import store from "../Store";

export const trackTrace = (traceMessage, customMessageForProperties) => {
  let { oidc, networkStateReducer, accountReducer } = store.getState();
  let userProfile = oidc.user && oidc.user.profile;
  let b2cObjectId = userProfile && userProfile.sub;
  let username = userProfile && userProfile.email;
  let isLoggedIn = accountReducer.isLoggedIn;
  let lastRequestedTime = networkStateReducer.lastRequestedTime;
  getAppInsights().trackTrace({
    message: traceMessage,
    severityLevel: SeverityLevel.Information,
    properties: {
      b2cObjectId,
      username,
      isLoggedIn,
      lastRequestedTime,
      messageToLog: customMessageForProperties
    }
  });
};

export const trackException = (errorMessage, customMessageForProperties) => {
  let { oidc } = store.getState();
  let userProfile = oidc.user && oidc.user.profile;
  let b2cObjectId = userProfile && userProfile.sub;
  let username = userProfile && userProfile.email;
  getAppInsights().trackException({
    exception: new Error(errorMessage),
    severityLevel: SeverityLevel.Error,
    properties: {
      errorToLog: customMessageForProperties,
      b2cObjectId: b2cObjectId,
      username: username
    }
  });
};
